import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Calendar } from "../components/ui/calendar";
import api from "../lib/api";

const CALENDAR_CLASS_NAMES = {
  months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
  table: "w-full border-collapse space-y-1",
  head_row: "flex",
  head_cell: "text-white/40 rounded-md w-10 h-9 flex items-center justify-center font-normal text-xs",
  row: "flex w-full mt-1",
  cell: "relative p-0.5 text-center text-sm w-10",
  day_selected: "bg-gold text-white hover:bg-gold hover:text-white focus:bg-gold focus:text-white",
  day_today: "border border-gold/50 text-gold",
  nav_button: "text-white border-white/20 hover:bg-white/10 h-8 w-8",
  caption_label: "text-white",
  day: "h-9 w-9 p-0 font-normal text-white/80 hover:bg-white/10 rounded-md aria-selected:opacity-100",
};

export const DateStep = ({ selectedDate, onSelect }) => {
  const { t, lang } = useLanguage();
  const [closedWeekdays, setClosedWeekdays] = useState([]);

  useEffect(() => {
    api.get("/working-hours").then(({ data }) => {
      setClosedWeekdays(data.filter((d) => !d.is_open).map((d) => (d.weekday + 1) % 7));
    }).catch(() => {});
  }, []);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 60);

  return (
    <div data-testid="booking-date-step">
      <h2 className="font-serif text-2xl text-white mb-6">{t("booking.selectDate")}</h2>
      <div className="bg-[#141414] border border-white/10 rounded-xl p-2 sm:p-4 inline-block">
        <Calendar
          data-testid="booking-calendar"
          mode="single"
          locale={undefined}
          selected={selectedDate}
          onSelect={onSelect}
          disabled={(date) => date < today || date > maxDate || closedWeekdays.includes(date.getDay())}
          className="text-white"
          classNames={CALENDAR_CLASS_NAMES}
        />
      </div>
      <p className="text-white/30 text-xs mt-3">{lang === "nl" ? "Gesloten dagen zijn niet selecteerbaar." : "Closed days cannot be selected."}</p>
    </div>
  );
};
